import Link from "next/link";
import styles from "../nature/NatureRectangle.module.css";

type ArchetypeRectangleProps = {
  slug: string;
  name: string;
  color: string;
};

export default function ArchetypeRectangle(props: ArchetypeRectangleProps) {
  return (
    <Link href={`/archetype-group/${props.slug}`}>
      <div
        style={{
          backgroundColor: props.color,
        }}
        className={styles.rectangleParent}
      >
        <h3>{props.name}</h3>
      </div>
    </Link>
  );
}
